import { StandardReportRow } from '../../report.models';
import { toEnglishDigits } from '../../report.utils';

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50];

export function buildSearchIndex(row: StandardReportRow): string {
  return toEnglishDigits(Object.values(row).join('\n')).toLowerCase();
}

export function sumReportField(rows: StandardReportRow[], field: keyof StandardReportRow): number {
  const sum = rows.reduce((total, row) => total + (Number(row[field]) || 0), 0);
  return Math.round((sum + Number.EPSILON) * 100) / 100;
}

export function formatReportMinutes(minutes: number): string {
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}
